export const getSizotsaFuneralCover = (state) =>
  state.sizotsaFuneralCover;
